import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
} from "@angular/core";
import { NbDialogRef } from "@nebular/theme";
import { EImportacaoType } from "../../table/EImportacaoType";
import { getImportacaoType } from "../../../utils/get-importacao-type";

@Component({
  selector: "ngx-modal-help.component",
  templateUrl: "./modal-help.component.html",
  styleUrls: ["./modal-help.component.scss"],
})
export class ModalHelpComponent implements OnInit, AfterViewInit {
  @ViewChild("help", { static: false })
  public help: ElementRef;
  @Input() importacaoType: EImportacaoType;

  public customLogin;
  public textoWhatsapp = "";
  EImportacaoType = EImportacaoType;

  constructor(protected ref: NbDialogRef<ModalHelpComponent>) {}

  ngOnInit(): void {
    const resCustom = localStorage.getItem("bway-customLogin");
    if (resCustom) {
      this.customLogin = JSON.parse(resCustom);
      if (this.customLogin && this.customLogin.whatsapp) {
        this.textoWhatsapp =
          "https://api.whatsapp.com/send?1=pt_br&phone=+" +
          this.customLogin.whatsapp +
          "&text=Ol%C3%A1,%20tudo%20bem?%20Poderia%20me%20ajudar?";
      }
    }
  }

  ngAfterViewInit(): void {
    if (this.help && this.help.nativeElement) {
      this.help.nativeElement.ownerDocument.activeElement.blur();
    }
  }

  close() {
    this.ref.close();
  }

  getUrlPdf() {
    switch (this.importacaoType) {
      case EImportacaoType.CARGA:
        return "https://1drv.ms/b/c/93e1aefddf1927ed/EU0J1Sh-OLhOl_JMfP9Ke4MBoEYKNmpgMd1bPzbfqkGwPA?e=dDqchZ";
      case EImportacaoType.ATIVACAO:
        return "";
      case EImportacaoType.FUNCIONARIO:
        return "";
      default:
        return "";
    }
  }

  getUrlVideo() {
    switch (this.importacaoType) {
      case EImportacaoType.CARGA:
        return "https://youtu.be/Z00w1rPMbpE";
      case EImportacaoType.ATIVACAO:
        return "";
      case EImportacaoType.FUNCIONARIO:
        return "https://youtu.be/Ab9TML2c93s";
      default:
        return "";
    }
  }

  getType = (type: EImportacaoType) => getImportacaoType(type).name;
}
